export default {
  getAfterFullMealData(unionId) {
    return this.http('DataInterface', 'get', `v1/health-record/get-user-after-full-meal-suggestion?union_id=${unionId}`);

  },
  getUserStateSuggestion(data) {
    return this.http('DataInterface', 'get', 'v1/health-record/list-user-state-suggestion', data);
  },
  createSuggestionLog(data) {
    return this.http('DataInterface', 'post', 'v1/health-record/create-user-suggestion-create-log', data);
  },
  listSuggestionLog(data) {
    return this.http('DataInterface', 'get', 'v1/health-record/list-user-suggestion-log', data);
  }
};
